import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import * as z from 'zod';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';

// Form schema
export const apiKeyFormSchema = z.object({
	name: z.string().min(1, 'Name is required'),
});

export type ApiKeyFormData = z.infer<typeof apiKeyFormSchema>;

interface ApiKeyFormProps {
	defaultValues?: Partial<ApiKeyFormData>;
	onSubmit: (data: ApiKeyFormData) => void;
	isLoading?: boolean;
}

export const ApiKeyForm = ({ defaultValues, onSubmit, isLoading }: ApiKeyFormProps) => {
	const form = useForm<ApiKeyFormData>({
		resolver: zodResolver(apiKeyFormSchema),
		defaultValues: {
			name: '',
			...defaultValues,
		},
	});

	return (
		<form onSubmit={form.handleSubmit(onSubmit)} className="grid gap-4 py-4">
			<div className="grid gap-2">
				<Label htmlFor="name">API Key Name</Label>
				<Input
					id="name"
					placeholder="e.g., Development, Production, Testing"
					{...form.register('name')}
				/>
				{form.formState.errors.name && (
					<p className="text-sm text-red-500">{form.formState.errors.name.message}</p>
				)}
			</div>

			<div className="flex justify-end mt-4">
				<Button type="submit" disabled={isLoading}>
					{isLoading ? 'Creating...' : 'Create API Key'}
				</Button>
			</div>
		</form>
	);
};

export default ApiKeyForm;
